// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchForm_search__2H8nE","search__btn":"SearchForm_search__btn__1DYIG"};